import { useCallback } from 'react';
import { useLocation } from '@namespace/i18n';
import { useHistory, useSearchParams } from '@namespace/router';

export const usePlexPaginationHandlePageChange = ({
  loadGames,
  pageSize,
  dontSetPageToUrl,
  isUseSearchQueryInUrl = false
}) => {
  const { pathname } = useLocation();
  const { replace } = useHistory();
  const { query = '' } = useSearchParams();

  const handlePageChange = useCallback(
    async (newPage) => {
      if (!dontSetPageToUrl) {
        const newUrl = `${pathname}?page=${newPage}${isUseSearchQueryInUrl ? `&query=${query}` : ''}`;
        replace(newUrl);
      }

      await loadGames({
        offset: pageSize * (newPage - 1),
        limit: pageSize
      });
    },
    [
      loadGames,
      pageSize,
      pathname,
      replace,
      query,
      dontSetPageToUrl,
      isUseSearchQueryInUrl
    ]
  );

  return handlePageChange;
};
